import React from 'react';
import Badge from '../../../components/ui/Badge';

const StatusBadge = ({ status }) => {
  const statusConfig = {
    vacant: {
      variant: 'success',
      label: 'Vacant'
    },
    occupied: {
      variant: 'primary',
      label: 'Occupied'
    },
    maintenance: {
      variant: 'warning',
      label: 'Maintenance'
    },
    reserved: {
      variant: 'accent',
      label: 'Reserved'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.vacant;

  return (
    <Badge variant={config?.variant} size="default">
      {config?.label}
    </Badge>
  );
};

export default StatusBadge;